let _ = require("ES/lib/lodash");
import dd from "ES/lib/dd";
import StandardLayout from "../layout/StandardLayout";

let AuthedUserSession = require("../../utils/AuthedUserSession");

module.exports = dd.createClass({
  render: function () {
    return StandardLayout(
      {},
      dd.div(
        { className: "container" },
        dd.div(
          {},
          dd.h1({}, "eSpeakers Lead Board"),
          dd.div(
            { className: "panel panel-default" },
            dd.div(
              { className: "panel-body" },
              dd.h4(
                {},
                "The eSpeakers Marketplace Lead Board has been upgraded and is easier to get to directly from the main dashboard."
              ),
              dd.hr(),
              dd.p(
                {},
                "The improved Lead Board now combines jobs from eSpeakers Marketplace, bureaus and associations, and sources across the web."
              ),
              dd.ul(
                {},
                dd.li(
                  {},
                  dd.span(
                    {},
                    "Some jobs in the Lead Board include a finders fee that varies from lead to lead. "
                  )
                ),
                dd.li(
                  {},
                  dd.span(
                    {},
                    "Any finders fee is always displayed clearly so that you will know your responsibility if you close the deal."
                  )
                )
              ),
              dd.p(
                {},
                "There are several new features that make it easier for you to find new jobs:"
              ),
              dd.ul(
                {},
                dd.li(
                  {},
                  "Filter jobs based on your chosen topics to find the best matched jobs"
                ),
                dd.li({}, "Sort jobs based on name, location, and budget"),
                dd.li(
                  {},
                  "Work with curated and public jobs all from a single page"
                ),
                dd.li(
                  {},
                  "Show or hide jobs from outside sites or internal directories"
                ),
                dd.li(
                  {},
                  "Find jobs by date range to more easily plan your schedule"
                ),
                dd.li(
                  {},
                  "Instantly communicate with the Bureau Agent to quickly get more information about a job to send a better proposal"
                )
              ),
              dd.p(
                {},
                "We are excited to offer these new tools to help you grow your speaking business."
              ),
              dd.div(
                { className: "text-center" },
                dd.a(
                  {
                    href:
                      "/dashboard/token-callback?token=" +
                      _.get(AuthedUserSession, ["balboa", "estoken"], "") +
                      "&redir=/" +
                      AuthedUserSession.getLastSelectedSID() +
                      "/lead-board/shortlists",
                  },
                  dd.button(
                    { className: "btn btn-primary" },
                    "Access The New Lead Board"
                  )
                )
              )
            )
          )
        )
      )
    );
  },
});
//
// export default function LeadBoard() {
//
//   return (
//     <div className={"container-fluid"}>
//       <h2>Important information the new eSpeakers Lead Board</h2>
//       <p>
//         We have moved the marketplace jobs and all other leads to your eSpeakers Dashboard.
//       </p>
//       <p>
//         You can search hundreds of jobs and apply to the ones that best match your speaking strengths.  Jobs that are available on a bureau will still require
//         a finder's fee; while Call for Speaker jobs are free to apply.
//       </p>
//       <p>
//         You can start your search today by going to the <a href={"/dashboard/lead-board"}>Lead Board</a>.
//       </p>
//     </div>
//   );
// }



// WEBPACK FOOTER //
// ./src/components/leadboard/index.js